import { render, staticRenderFns } from "./RichTextViewer.vue?vue&type=template&id=e6b476b4"
import script from "./RichTextViewer.vue?vue&type=script&lang=js"
export * from "./RichTextViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports